<!--
 * @Description: 客户账号详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-02-24 15:23:10
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <CosViewContent>
        <a-tabs>
          <a-tab-pane key="1" tab="基本信息">
            <baseMessage :id="route.query.id" returnName="DcCosFbuAccountCode" />
          </a-tab-pane>
          <a-tab-pane key="2" tab="商机">
            <tabsBusiness
              returnName="DcCosFbuAccountCode"
              :arkCodeId="route.query.id"
              :permissionPage="permissionBuss"
            />
          </a-tab-pane>
          <a-tab-pane key="3" tab="合同信息">
            <tabsContract returnName="DcCosFbuAccountCode" />
          </a-tab-pane>
          <a-tab-pane key="4" tab="转化记录">
            <TabsConversion returnName="DcCosFbuAccountCode" :resourceId="route.query.id" />
          </a-tab-pane>
          <a-tab-pane key="5" tab="操作日志">
            <TabsOperationLog appId="cos_fbu" tableId="FbuAccountCodeOperationLog" :resourceId="route.query.id" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
      <cos-footer-button :disabled="true" :hideOk="true" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import baseMessage from './components/baseMessage.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsConversion from '@/components/TabsConversion'
import tabsContract from '@/views/gucangSales/customerCenter/components/tabsContract.vue'
import tabsBusiness from '@/views/gucangSales/customerCenter/components/tabsBusiness.vue'
</script>
<script setup lang="ts">
import { useRoute } from 'vue-router'
const route = useRoute()
const permissionBuss = {
  add: 'fbu_arkcode_buss_add_btn',
  edit: 'fbu_arkcode_buss_edit_btn',
  del: 'fbu_arkcode_buss_del_btn'
}
</script>
